<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <CardBorder :title="$t('views.section.requestDetail')">
            <Form :colon="false" :ref="(e) => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldOriginal"
                                 :skeleton="isLoading"></TemplateBuilder>
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldRequestDetails"
                                 :skeleton="isLoading"></TemplateBuilder>
                <!-- force render tab because need validate all tab -->
                <!-- eslint-disable-next-line vue/no-mutating-props -->
                <Tabs v-model:activeKey="menuContext.tabKeyRequester" type="card" class="mt-3"
                      :tabBarStyle="{ paddingLeft: '11.4em !important' }">
                    <TabPane key="Requester" :forceRender="true" v-if="!['editRegistration'].includes(data.useForm.modelRef?.refChangeLicenseObjective?.key)">
                        <template v-slot:tab>
                            <CIcon file="user-transfer.svg"></CIcon>
                            {{ $t("views.request.licenseRequest.requester") }}
                        </template>
                        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldRequester"
                                         :skeleton="isLoading">
                        </TemplateBuilder>
                    </TabPane>
                    <TabPane key="Requester" :forceRender="true" v-if="['editRegistration'].includes(data.useForm.modelRef?.refChangeLicenseObjective?.key)">
                        <template v-slot:tab>
                            <CIcon file="user-transfer.svg"></CIcon>
                            {{ $t("views.request.licenseRequest.requesterCurrent") }}
                        </template>
                        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldRequester"
                                         :skeleton="isLoading">
                        </TemplateBuilder>
                    </TabPane>
                    <TabPane key="OwnerOriginal" :forceRender="true"
                             v-if="['editRegistration'].includes(data.useForm.modelRef?.refChangeLicenseObjective?.key)">
                        <template v-slot:tab>
                            <CIcon file="connection.svg"></CIcon>
                            {{ $t("views.request.licenseRequest.ownerOriginal") }}
                        </template>
                        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm"
                                         :fields="data.fieldOwnerOriginal" :skeleton="isLoading">
                        </TemplateBuilder>
                    </TabPane>
                </Tabs>
                <TemplateBuilder
                        :rowProp="data.rowProp"
                        :useForm="data.useForm"
                        :fields="data.fieldChangeRequestLicense"
                        :skeleton="isLoading"
                ></TemplateBuilder>
            </Form>
            <!-- force render tab because need validate all tab -->
            <!-- eslint-disable-next-line vue/no-mutating-props -->
            <Tabs v-model:activeKey="menuContext.tabKey" type="card" class="mt-3">
                <TabPane key="Vessel" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="fishing-boat.svg"></CIcon>
                        {{ $t("views.vessel.title") }}
                    </template>
                    <Row>
                        <Col class="mt-2" :xs="24" :lg="['editRegistration', 'replaceBoat'].includes(data.useForm?.modelRef?.refChangeLicenseObjective?.key) ? 12: 24">
                            <CardBorder :title="$t('views.section.boatOld')">
                                <VesselForm
                                        :menuContext="menuContext"
                                        :viewOnly="viewOnly"
                                        :dataProp="data"
                                        :isLoading="isLoading"
                                        itemsKey="refOriginal.refVesselRequest"
                                ></VesselForm>
                            </CardBorder>
                        </Col>
                        <Col class="mt-2" :xs="24" :lg="12" v-if="['editRegistration', 'replaceBoat'].includes(data.useForm?.modelRef?.refChangeLicenseObjective?.key)">
                            <CardBorder :title="['editRegistration'].includes(data.useForm?.modelRef?.refChangeLicenseObjective?.key) ? $t('views.section.editBoatRegistration') :$t('views.section.boatNew') ">
                                <VesselForm
                                        :menuContext="menuContext"
                                        :viewOnly="viewOnly"
                                        :dataProp="data"
                                        :isLoading="isLoading"
                                        itemsKey="refVesselRequest"
                                ></VesselForm>
                            </CardBorder>
                        </Col>
                    </Row>
                </TabPane>
                <TabPane key="VesselOwner" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="fisher-man.svg"></CIcon>
                        {{ $t("views.vesselOwner.title") }}
                    </template>
                    <Row>
                        <!--<Col :xs="24" :lg="12">-->
                            <!--<CardBorder>-->
                                <!--<VesselOwnerList-->
                                        <!--:menuContext="menuContext"-->
                                        <!--:viewOnly="viewOnly"-->
                                        <!--:dataProp="data"-->
                                        <!--:isLoading="isLoading"-->
                                        <!--itemsKey="refOriginal.refVesselRequest.vesselOwnerRequests"-->
                                <!--&gt;</VesselOwnerList>-->
                            <!--</CardBorder>-->
                        <!--</Col>-->
                        <Col class="mt-2" :xs="24" :lg="24">
                            <CardBorder :title="$t('views.vesselOwner.title')">
                                <VesselOwnerList
                                        :menuContext="menuContext"
                                        :viewOnly="viewOnly"
                                        :dataProp="data"
                                        :isLoading="isLoading"
                                        itemsKey="refVesselRequest.vesselOwnerRequests"
                                ></VesselOwnerList>
                            </CardBorder>
                        </Col>
                    </Row>
                </TabPane>
                <TabPane key="FishingTool" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="fishing-tool.svg"></CIcon>
                        {{ $t("views.fishingTool.title") }}
                    </template>
                    <Row>
                        <Col class="mt-2" :xs="24" :lg="['tool'].includes(data.useForm?.modelRef?.refChangeLicenseObjective?.key) ? 12: 24" >
                            <CardBorder class="h-100" :title="$t('views.section.toolOld')" >
                                <FishingToolList
                                        :menuContext="menuContext"
                                        :viewOnly="viewOnly || ![undefined, 'draft'].includes(data?.useForm?.modelRef?.refStatus?.key)"
                                        :dataProp="data"
                                        :isLoading="isLoading"
                                        itemsKey="refOriginal.fishingToolRequests"
                                ></FishingToolList>

                            </CardBorder>
                        </Col>
                        <Col :xs="24" :lg="12" class="mt-2" v-if="['tool'].includes(data.useForm?.modelRef?.refChangeLicenseObjective?.key)">
                            <CardBorder class="h-100" :title="$t('views.section.toolNew')">
                                <FishingToolList
                                        :menuContext="menuContext"
                                        :viewOnly="viewOnly"
                                        :dataProp="data"
                                        :isLoading="isLoading"
                                        itemsKey="fishingToolRequests"
                                ></FishingToolList>

                            </CardBorder>
                        </Col>
                    <!--    <Col :xs="24" :lg="24">
                            <FishingToolDeclarationForm
                                    v-if="
                                           data?.useForm?.modelRef?.fishingToolDeclarations?.length > 0
                                           && data?.useForm?.modelRef?.refChangeLicenseObjective?.key == 'tool'
                                        "
                                    :menuContext="menuContext"
                                    :viewOnly="viewOnly || ![undefined, 'draft'].includes(data?.useForm?.modelRef?.refStatus?.key)"
                                    :dataProp="data"
                                    :isLoadingProp="isLoading"
                                    itemsKey="fishingToolDeclarations"
                            ></FishingToolDeclarationForm>
                        </Col>-->
                    </Row>
                    <Row id="fishingToolDeclaration" class="mt-2" v-if="data?.useForm?.modelRef?.fishingToolDeclarations?.length > 0
                            && data?.useForm?.modelRef?.refChangeLicenseObjective?.key == 'tool'"
                    >
                        <Tabs v-model:activeKey="data.tabFishingToolDeclarationKey" >
                        <TabPane key="OldFishingToolDeclaration" :tab="['tool'].includes(data.useForm?.modelRef?.refChangeLicenseObjective?.key) ? $t('views.tabs.oldFishingToolDeclarations') : $t('views.tabs.fishingToolDeclarations')" :forceRender="true">
                            <FishingToolDeclarationForm
                                    v-if="data?.useForm?.modelRef?.refOriginal?.fishingToolDeclarations?.length > 0"
                                    :menuContext="menuContext"
                                    :viewOnly="true"
                                    :dataProp="data"
                                    :isLoadingProp="isLoading"
                                    itemsKey="refOriginal.fishingToolDeclarations"
                            ></FishingToolDeclarationForm>
                        </TabPane>
                            <TabPane key="FishingToolDeclaration" :tab="$t('views.tabs.fishingToolDeclarations')" :forceRender="true">
                            <FishingToolDeclarationForm
                                    v-if="data?.useForm?.modelRef?.fishingToolDeclarations?.length > 0"
                                    :menuContext="menuContext"
                                    :viewOnly="viewOnly || ![undefined, 'draft', 'waitModify'].includes(data?.useForm?.modelRef?.refStatus?.key)"
                                    :dataProp="data"
                                    :isLoadingProp="isLoading"
                                    itemsKey="fishingToolDeclarations"
                            ></FishingToolDeclarationForm>
                        </TabPane>
                    </Tabs>
                    </Row>
                </TabPane>
                <TabPane key="Attachment" :tab="$t('views.attachment.title')" :forceRender="true">
                    <AttachmentForm
                            :menuContext="menuContext"
                            :viewOnly="viewOnly"
                            :dataProp="data"
                            :isLoading="isLoading"
                            group="LicenseRequestAttachment"
                    ></AttachmentForm>
                </TabPane>
            </Tabs>
        </CardBorder>

        <CardBorder :title="$t('views.section.officerAudit')"
                    v-if="![undefined, 'draft'].includes(data.useForm?.modelRef?.refStatus?.key)">
            <Form :colon="false" :ref="(e) => (refs.form = e)" layout="horizontal">
                <TemplateBuilder
                        :rowProp="data.rowProp"
                        :useForm="data.useForm"
                        :fields="data.fieldOfficerConsider"
                        :skeleton="isLoading"
                ></TemplateBuilder>
            </Form>
            <Form :colon="false" :ref="(e) => (refs.form = e)" layout="horizontal">
                <TemplateBuilder
                        :rowProp="data.rowProp"
                        :useForm="data.useForm"
                        :fields="data.fieldRDConsider"
                        :skeleton="isLoading"
                ></TemplateBuilder>
            </Form>
            <Form :colon="false" :ref="(e) => (refs.form = e)" layout="horizontal">
                <TemplateBuilder
                        :rowProp="data.rowProp"
                        :useForm="data.useForm"
                        :fields="data.fieldLawyerConsider"
                        :skeleton="isLoading"
                ></TemplateBuilder>
            </Form>
            <Form :colon="false" :ref="(e) => (refs.form = e)" layout="horizontal" 
                v-if="data?.useForm?.modelRef?.refLawyerStatus?.key == 'disagree'">
                <TemplateBuilder
                        :rowProp="data.rowProp"
                        :useForm="data.useForm"
                        :fields="data.fieldArgueLawyerConsider"
                        :skeleton="isLoading"
                ></TemplateBuilder>
            </Form>
            <Form :colon="false" :ref="(e) => (refs.form = e)" layout="horizontal">
                <TemplateBuilder
                        :rowProp="data.rowProp"
                        :useForm="data.useForm"
                        :fields="data.fieldDofCenterConsider"
                        :skeleton="isLoading"
                ></TemplateBuilder>
            </Form>
            <Form :colon="false" :ref="(e) => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldDirector"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
        </CardBorder>
        <CardBorder :title="$t('views.section.appellant')" v-if="['notApprove', 'appeal'].includes(data.useForm?.modelRef?.refStatus?.key) || data.useForm?.modelRef?.isHaveAppealedRequest">
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldAppealRequest"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
        </CardBorder>
        <ChangeLogCollapse
                class="mt-2"
                v-if="visibleChangeLog && data.id"
                :id="data.id"
                :onCallChangeLog="({ id, page, size }) => onCallChangeLog({ id, page, size, createSearchOneCriteria, callChanges })"
                :mappings="[...fieldLogs]"
        ></ChangeLogCollapse>
    </Card>
</template>

<script>
    import { Card, Form, Tabs, Row, Col } from "ant-design-vue";
    import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
    import { useRoute } from "vue-router";
    import { state as stateApp } from "../../../../../app.logic";
    //import { useI18n } from "vue-i18n";
    import {
        createFormTitle,
        initForm,
        isLoading,
        onClickModalOk,
        callChanges,
        createSearchOneCriteria
    } from "./change-license.logic";
    import { state } from "../request.logic";
    import { onCallChangeLog } from "../../../../../utils/form";
    import lodash from "lodash";

    export default defineComponent({
        components: {
            Card,
            Row,
            Col,
            Form,
            Tabs,
            TabPane: Tabs.TabPane,
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
            CardBorder: defineAsyncComponent(() => import("../../../../../components/card/CardBorder")),
            VesselForm: defineAsyncComponent(() => import("./vessel/VesselForm")),
            VesselOwnerList: defineAsyncComponent(() => import("./vessel-owner/VesselOwnerList")),
            FishingToolList: defineAsyncComponent(() => import("./fishing-tool/FishingToolList")),
            FishingToolDeclarationForm: defineAsyncComponent(() => import("../../fishing-tool-declaration/FishingToolDeclarationForm")),
            AttachmentForm: defineAsyncComponent(() => import("../../attachment/AttachmentForm")),
            CIcon: defineAsyncComponent(() => import("../../../../../components/icon/CIcon")),
            ChangeLogCollapse: defineAsyncComponent(() => import("../../../../../components/change-log/ChangeLogCollapse")),
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            routerPrefix: { default: "change-license-requests" },
            licenseType: {},
            viewOnly: { default: false },
            form: {},
            setAppPageHeader: { default: true },
            visibleChangeLog: { default: true },
            forceDefault: { default: false },
            isRouteFromMyJob: { default: false }
        },
        setup(props) {
            // eslint-disable-next-line vue/no-mutating-props
            //const i18n = useI18n();
            const route = useRoute();
            const id = props.form ? props.form.id : route.params?.id;
            const data = reactive({
                rowProp: { gutter: 24 },
                id,
                fieldLogs: [],
                sendReceive: false,
                tabRequester: "Requester",
                tabFishingToolDeclarationKey: "FishingToolDeclaration"
            });
            const refs = reactive({ form: null });
            initForm({ props, data, refs, route });
            const callOnClickModalOk = () => onClickModalOk({ data, refs });
            const title = computed(() => createFormTitle({ data }));
            const fieldLogs = computed(() => {
            return lodash.cloneDeep(data.fieldLogs).map((d) => {
                //const oldLabel = d.label;
                // if (d.key?.startsWith("refCompany.refFactoryAddrTh") || d.key === "refCompany.factoryTambonTh")
                //     d.label = () => `${i18n.t("model.company.refFactoryAddrTh")} ${oldLabel?.()}`;
                // if (d.key?.startsWith("refCompany.refFactoryAddrEn") || d.key === "refCompany.factoryTambonEn")
                //     d.label = () => `${i18n.t("model.company.refFactoryAddrEn")} ${oldLabel?.()}`;
                // if (d.key?.startsWith("refCompany.refOfficeAddrTh") || d.key === "refCompany.officeTambonTh")
                //     d.label = () => `${i18n.t("model.company.refOfficeAddrTh")} ${oldLabel?.()}`;
                // if (d.key?.startsWith("refCompany.refOfficeAddrEn") || d.key === "refCompany.officeTambonEn")
                //     d.label = () => `${i18n.t("model.company.refOfficeAddrEn")} ${oldLabel?.()}`;
                return d;
            });
        });
            return {
                props,
                data,
                refs,
                state,
                title,
                isLoading,
                fieldLogs,
                callOnClickModalOk,
                callChanges,
                createSearchOneCriteria,
                onCallChangeLog
            };
        }
    });
</script>
